import { ZafAppLocation } from "@localtypes/zafTypes";
import { useEffect, useState } from "react";
import { useCustomer } from "./useCustomer";
import { BusinessCode } from "@localtypes/generated-gql";
import { businessCodeToBrandIdMap } from "src/App";

export const useBrandedCustomer = (location: ZafAppLocation) => {
    const [customerId, setCustomerId] = useState<string>();
    const [customerSalesforceId, setCustomerSalesforceId] = useState<
        null | string
    >();
    const [loading, setLoading] = useState<boolean>(true);
    const [selectedCustomerBrand, setSelectedCustomerBrand] =
        useState<BusinessCode>(BusinessCode.Gat);
    const [businessId, setBusinessId] = useState<string>();
    const [hasMultipleIds, setHasMultipleIds] = useState<boolean>(false);
    const inUserSidebar = location === "user_sidebar";

    const {
        abeCustomerId: abeCustomerId,
        salesforceContactId,
        customerName,
        loading: customerLoading,
        ticketBrandId,
    } = useCustomer(location);

    const getBusinessCodeByBrandId = (
        brandId: undefined | string,
    ): BusinessCode => {
        const businessCode = Object.keys(businessCodeToBrandIdMap)
            .filter((key): key is BusinessCode => !!key)
            .find((key) => businessCodeToBrandIdMap[key] === brandId);

        if (!businessCode) {
            throw new Error(`No business code found for brand ID: ${brandId}`);
        }

        return businessCode;
    };

    const setIds = (
        customer: string,
        salesforceContactId: null | string,
        business: "GAT" | "UB" | "ADV",
    ) => {
        setCustomerId(customer);
        setCustomerSalesforceId(salesforceContactId);

        if (businessCodeToBrandIdMap[business]) {
            setBusinessId(businessCodeToBrandIdMap[business]);
        }
    };

    useEffect(() => {
        if (customerLoading) {
            setLoading(true);
            return;
        }

        if (!abeCustomerId) {
            return;
        }

        setIds(
            abeCustomerId,
            salesforceContactId ?? null,
            selectedCustomerBrand,
        );
        setSelectedCustomerBrand(getBusinessCodeByBrandId(ticketBrandId));
        setHasMultipleIds(false);
        setLoading(false);
    }, [
        ticketBrandId,
        salesforceContactId,
        customerName,
        selectedCustomerBrand,
        inUserSidebar,
        loading,
        customerLoading,
        abeCustomerId,
    ]);

    return {
        customerId,
        customerName,
        customerSalesforceId,
        selectedCustomerBrand,
        businessId,
        loading: loading || customerLoading,
        inUserSidebar,
        hasMultipleIds,
        setSelectedCustomerBrand,
    };
};
